import { Check, Phone } from "lucide-react";
import { Reveal, TEL, PHONE } from "./shared";

const points = [
  "Consistent, detail-oriented quality on every visit",
  "Eco-friendly products safe for kids & pets",
  "Flexible scheduling that fits your life",
  "Transparent flat-rate pricing, no hidden fees",
];

export default function WhyUs() {
  return (
    <section data-testid="why-us" className="bg-[#FAFAFA] py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1642505172378-a6f5e5b15580?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBjbGVhbmluZyUyMGJyaWdodCUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3ODMzNjIyODZ8MA&ixlib=rb-4.1.0&q=85"
              alt="Cleaning with care"
              className="rounded-3xl w-full h-[520px] object-cover shadow-[0_20px_60px_rgba(43,81,86,0.12)]"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal text-white rounded-3xl px-8 py-6 shadow-xl hidden sm:block animate-floaty-slow">
              <p className="font-serif-display text-4xl">1000+</p>
              <p className="text-sm text-blush">Happy Edmonton homes</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="text-sm uppercase tracking-[0.25em] text-pink-dark font-semibold mb-4">Why Choose Us</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-teal font-medium leading-tight">
            A cleaning company that genuinely cares
          </h2>
          <p className="mt-5 text-lg text-teal-soft leading-relaxed">
            We're more than a cleaning service. We treat every home with a gentle, thoughtful touch —
            never rushing, always paying attention to the little details that make a space feel truly cared for.
          </p>
          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-pink/40 flex items-center justify-center text-teal shrink-0">
                  <Check size={15} strokeWidth={2} />
                </span>
                <span className="text-teal-soft text-lg">{p}</span>
              </li>
            ))}
          </ul>
          <a
            href={TEL}
            data-testid="whyus-call-button"
            className="mt-10 inline-flex items-center gap-3 bg-teal text-white hover:bg-teal-dark rounded-full px-8 py-4 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <Phone size={18} strokeWidth={1.5} /> Call {PHONE}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
